import React from "react";
import { useNavigate } from "react-router-dom";
import "../style/Developer.css";
import logo from "../assets/images/teteklogo-removebg-preview.png";

const Developer = () => {
  const navigate = useNavigate();

const startTest = (topic) => {
  navigate("/ques", { state: { topic } }); // 👈 pass topic as state
};

  return (
    <div className="developer__body">
      <div className="developer__header">
        <div className="developer__company-name">
          <img src={logo} alt="Logo" style={{ height: "45px", objectFit: "contain" }} />
        </div>
        <div className="developer__title">AI Interview Mock Test</div>
        <div className="developer__subtitle">
          Choose your role to begin a smart, AI-powered test
        </div>
      </div>

      {/* Section: Programming Languages */}
      <h2 className="developer__section-title">Programming Languages</h2>
      <div className="developer__card-grid">
        <div className="developer__card" onClick={() => startTest("python")}>
          <img src="https://cdn-icons-png.flaticon.com/512/5968/5968350.png" alt="Python" className="developer__card-image" />
          <h2 className="developer__card-title">Python</h2>
          <button className="developer__start-btn">Start Test</button>
        </div>

        <div className="developer__card" onClick={() => startTest("java")}>
          <img src="https://cdn-icons-png.flaticon.com/512/226/226777.png" alt="Java" className="developer__card-image" />
          <h2 className="developer__card-title">Java</h2>
          <button className="developer__start-btn">Start Test</button>
        </div>

        <div className="developer__card" onClick={() => startTest("sql")}>
          <img src="https://cdn-icons-png.flaticon.com/512/4248/4248443.png" alt="SQL" className="developer__card-image" />
          <h2 className="developer__card-title">SQL</h2>
          <button className="developer__start-btn">Start Test</button>
        </div>
      </div>

      <footer className="developer__footer">© 2025 Vienstereoptic. All rights reserved.</footer>
    </div>
  );
};

export default Developer;
